import { SITE_PLAN_LEGEND } from "@/lib/sitePlan";

export function SitePlanLegend({ compact = false }: { compact?: boolean }) {
  if (compact) {
    return (
      <ul className="flex flex-wrap gap-x-3 gap-y-1.5" aria-label="Legende">
        {SITE_PLAN_LEGEND.map((item) => (
          <li
            key={item.label}
            className="inline-flex min-w-0 items-center gap-1.5 text-[0.6875rem] leading-none text-label-secondary"
          >
            <span
              className={`site-plan-legend__swatch site-plan-legend__swatch--${item.accent}`}
              aria-hidden
            />
            <span className="min-w-0">{item.label}</span>
          </li>
        ))}
      </ul>
    );
  }

  return (
    <div className="site-plan-legend">
      <p className="text-xs font-medium uppercase tracking-wide text-label-tertiary">
        Status
      </p>
      <ul className="mt-2.5 grid grid-cols-2 gap-x-4 gap-y-2.5 sm:grid-cols-3 lg:grid-cols-4">
        {SITE_PLAN_LEGEND.map((item) => (
          <li
            key={item.label}
            className="flex min-w-0 items-center gap-2.5 text-xs leading-snug text-label-secondary"
          >
            <span
              className={`site-plan-legend__swatch site-plan-legend__swatch--${item.accent}`}
              aria-hidden
            />
            <span className="min-w-0">{item.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
